import { getURLSearchParams, ISODateRangeToTimestampFilter } from '.';

interface GetTimestampFilterFromURLParamsInput {
    defaultValue: Record<string, TableStringFilterInput>;
    search: string;
    urlParamKeys: {
        end: string;
        start: string;
    };
}

/**
 * @param defaultValue - a default filter input that contains a `timestamp` value. This is returned
 * if both the `start` and `end` value cannot be found in the URL.
 * @param search - a location.search value from react-router-dom's  `useLocation().search` or
 * `useHistory().location.search`
 * @param urlParams - keys to use when looking up URL parameters from `search` for the start and end
 * dates of the date range
 * @returns an object that can be used as the `filter` input for a paginated AppSync query,
 * containing a `timestamp` value that is calculated from the URL parameters
 */
export const getTimestampFilterInputFromURLParams = ({
    defaultValue,
    search,
    urlParamKeys,
}: GetTimestampFilterFromURLParamsInput): Record<
    string,
    TableStringFilterInput
> => {
    const { end, start } = urlParamKeys;

    const dateURLParams = getURLSearchParams({
        search,
        configs: [
            {
                defaultValue: null,
                paramKey: end,
            },
            {
                defaultValue: null,
                paramKey: start,
            },
        ],
    });

    const timestampFilter = ISODateRangeToTimestampFilter({
        end: dateURLParams[end],
        start: dateURLParams[start],
    });

    if (timestampFilter === null) {
        return defaultValue;
    }

    return {
        timestamp: timestampFilter,
    };
};
